export default "__VITE_ASSET__BvxYdjlM__"